import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['input', 'message', 'optionsContainer']

  initialize() {
    this.debounceValidate = debounce(this.validationMessage.bind(this), 300, false)
    this.casRegex = new RegExp('^\\d{2,7}-\\d{2}-\\d$')
  }

  validationMessage() {
    this.messageTarget.innerHTML = ''
    if (this.inputTarget.value === '') {
      return
    } else if (this.validate()) {
      let el = document.createElement('span')
      el.classList.add('text-success')
      el.textContent = 'Valid CAS Number'
      this.messageTarget.append(el)
    } else {
      let el = document.createElement('span')
      el.classList.add('text-danger')
      el.textContent = 'Invalid CAS Number'
      this.messageTarget.append(el)
    }
  }

  validate() {
    let casNumber = this.inputTarget.value
    return this.casRegex.test(casNumber)
  }

  searchCasNumber() {
    if (this.validate()) {
      let checkbox = this.buildCheckbox()
      this.optionsContainerTarget.append(checkbox)
      this.report()
    } else {
      alert('Only valid CAS Numbers can be used')
    }
  }

  report() {
    let selectedOptions = []
    let optionEls = this.element.querySelectorAll('input[type="checkbox"]')
    if (optionEls.length === 0) { return }

    let name = optionEls[0].name
    for (let option of optionEls) {
      if (option.checked) { selectedOptions.push(option.value) }
    }
    this.dispatch(
      'filter-options',
      { detail: { name: name, options: selectedOptions, noSubmit: this.noSubmitValue } }
    )
  }

  buildCheckbox() {
    let index = this.optionsContainerTarget.children.length
    let casNumber = this.inputTarget.value
    let checkbox = document.createElement('input')
    checkbox.type = 'checkbox'
    checkbox.value = casNumber
    checkbox.checked = true
    checkbox.id = `cas_number_option_${index}`
    checkbox.name = this.inputTarget.name
    let span = document.createElement('span')
    span.textContent = casNumber
    let label = document.createElement('label')
    label.for = checkbox.id
    label.append(checkbox)
    label.append(span)
    return label
  }
}
